import './playground.scss';

import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { AuthService, User } from '@skinsoft/auth';
import { fetch, FetchError, Proxy } from '@skinsoft/network';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Navbar } from '@skinsoft/ui';
import { Subject } from 'rxjs';
import { Component, Prop } from 'vue-property-decorator';

import { OfflineRibbon, ServiceWorkerLifecycle } from '@skinsoft/offline-mode';
import { throttleTime } from 'rxjs/operators';
import { router, Routes } from '../../../router';
import { ActionBar } from '../action-bar';

@Component({
    components: {
        sActionBar: ActionBar,
        sNavbar: Navbar,
        sOfflineRibbon: OfflineRibbon,
        sServiceWorkerLifecycle: ServiceWorkerLifecycle,
    },
    props: ['embeddedMode'],
    template: require('./playground.html'),
})
export class Playground extends ReactiveVue {
    public $authService: AuthService;
    public ready: boolean = false;
    public loadingIcon = faCircleNotch;
    public slowNetwork = false;
    public hasItemFocus = false;

    @Prop({ type: Boolean, default: "false" })
    public embeddedMode: boolean;

    private error$ = new Subject<FetchError>();

    public async created() {
        let timeoutId: NodeJS.Timer | null;

        timeoutId = setTimeout(() => {
            this.slowNetwork = true;
            timeoutId = null;
        }, 10e3);

        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        Proxy.onError(error => this.error$.next(error));
        this.subscribeTo(this.error$.pipe(throttleTime(100)), this.onProxyError);
        this.ready = true;
    }

    public mounted() {
        this.subscribeTo(this.$authService.waitForUser$(), this.onUser);
    }

    private onUser(user: User | null) {
        if (user) {
            return;
        }

        if (router.currentRoute.name !== Routes.LOGIN) {
            router.push({ name: Routes.LOGIN });
        }
    }

    private onProxyError(error: FetchError) {
        let message: string;

        switch (error.status) {
            case 404:
                message = this.$t('proxy.error.notFound', { uri: error.uri }) as string;
                break;
            case 401:
                if (router.currentRoute.name === Routes.LOGIN) {
                    return;
                }

                this.$authService.logOut();
                message = this.$t('proxy.error.tokenHasExpired') as string;
                break;
            default:
                if (fetch.isNetworkError(error)) {
                    if (!window.navigator.onLine) {
                        return;
                    }
                    message = this.$t('proxy.error.network') as string;
                } else {
                    return;
                }
                break;
        }

        this.$toasted.show(message, {
            action: [
                {
                    onClick: (_, toastObject) => {
                        toastObject.goAway(0);
                    },
                    text: 'Fermer',
                },
            ],
            duration: 3e3,
            fitToScreen: true,
            fullWidth: true,
            position: 'bottom-center',
            singleton: true,
        });
    }

    toggleItemFocus(hasFocus: boolean): void {
        this.hasItemFocus = hasFocus;
    }
}
